var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/40bbb513b5c73cabf5e60eec69c5f622.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ef04d041b08231b545823a64b4b28b4d.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    